import styles from './Coupon.module.css'
import WaitLoader from "../../WaitLoader/WaitLoader";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setOrderData} from "../../Reducer/GlobalReducer";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import {async} from "rxjs";
import errorLineItem from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import {Link} from "react-router-dom";
interface IUseCoupon
{
    orderId?: string
    sessionId?:string
    couponId:string
}

interface IActionData
{
    orderId: string
    sessionId:string
    couponId:string

    action:string
    data:any

}

interface ICouponProps
{
    cbExecute: ()=>void
}


interface IActionItem {
    name : string
    waitComplete: boolean
    data: any
    valid:boolean
    handle?:  (x:IActionItem)=>Promise<boolean>

}


export default function Coupon({cbExecute}:ICouponProps)
{

    const orderData = useSelector((state: ReduxStateInt) => {
        return state.orderData
    })
    const dispatch = useDispatch()


    const [showNote , setShowNote] = useState(false)

    const [link, setLink] = useState("")
    const [showLink, setShowLink] = useState(false)


    const couponResult = useRef<ErrorLineItemRef>(null)
    const [coupon, setCoupon] = useState("")
    const [discount, setDiscount ] = useState(0)

    const couponData = useRef<IUseCoupon>()
    const [ldrCoupon,rsCoupon,exCoupon] = useApiQuery("/sell/sim/order/coupon/apply","post",couponData);

    const couponActionData = useRef<IActionData>()
    const [ldrActionCoupon,rsActionCoupon,exActionCoupon] = useApiQuery("/sell/sim/order/coupon/action","post",couponActionData);


    const [couponAction,setCouponAction] = useState<IActionItem[]>([])
    const dataCardItem = useSelector((state: ReduxStateInt) => {
        return state.slider.dataCardItem
    })




    useEffect(()=>{
        if(coupon && coupon?.length)
        {
            setShowNote(true)
            return
        }
        setShowNote(false)
    },[coupon])



    const handleCoupon = () =>{
        const cpn = coupon?.match(/.{3,15}/ui)
        if(! cpn)
        {
            if(couponResult.current)couponResult.current.show("Не верный формат купона ( 3-15 знаков )", true,3000)
            return
        }
        couponData.current = {
            couponId: coupon,
            orderId: orderData?.orderId ,
            sessionId: orderData?.sessionId
        }
        setShowLink(false)

        exCoupon().then((e)=>{
            if(e?.success)
            {
                if(e?.payload?.newPrice !== undefined)
                {
                    dispatch(setOrderData({...orderData,tarifData: {...orderData.tarifData, price: e?.payload?.newPrice} }))
                    if(couponResult.current)couponResult.current.show(`Купон применен новая цена ${e?.payload?.newPrice} руб.`, false,0)

                    if(e?.payload?.action) parseCouponAction(e?.payload?.action)
                    setShowNote(false)
                    return

                }

                if(couponResult.current)couponResult.current.show("Не указана новая цена", true,3000)
                return
            }
            if(couponResult.current)couponResult.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера", true,3000)
            setShowNote(false)
            if(e?.payload?.link){
                setLink(e?.payload?.link)
                setShowLink(true)
            }

        })


    }

    const parseCouponAction = (act:string )=>{
        const action = act?.split(";")
        if(!action?.length) return null
        const xAction = new Array<IActionItem>()

        action?.map((item,idx)=>{

            if(item?.match(/inn/ui))xAction.push({
                name: 'inn',
                data: "",
                waitComplete: true,
                valid: false,
                handle: handleActionInn
            })
           /* if(item?.match(/noself/ui))
            {
                changeRegMode()
                xAction.push({
                    name: 'noself',
                    data: "",
                    waitComplete: false,
                    valid: false,
                })
            }*/

        })
        setCouponAction(xAction)

    }





    const getCouponActionItem = (name: string)=>
    {
        return couponAction?.filter((item)=>item?.name === name)
    }
    const setCouponActionData = (item: IActionItem)=>{
        let x = couponAction
        const y = getCouponActionItem(item?.name)
        if(y?.length === 0)
        {
            x.push(item)
            setCouponAction(x)
            return
        }
        x = couponAction.map((itm)=>{
            if(itm.name === item?.name) return item
            return itm
        })
        setCouponAction(x)


    }


    const buildInnAction = ()=>{
        const x = getCouponActionItem('inn')
        if( ! x?.length)return null
        const item = x[0]
        return (
            <div className={styles.coupMain}>
                <div >
                    <div className={styles.inpNoteCont}>
                        <div className={styles.innText}>По данному купону необходим ИНН</div>
                    </div>
                    <InputItem
                        val={item?.data}
                        mode={"e"}
                        title={"Инн"}
                        info={"ИНН самозанятого"}
                        maxLen={12}
                        regExp={/^[0-9]{12}$/ui}
                        placeHolder={"XXXXXXXXXXXX"}
                        onChange={(e)=>{
                            item.valid = e?.match(/^[0-9]{12}$/ui) ? true :false
                            item.data = e
                            setCouponActionData(item)

                        }}
                    />

                </div>


            </div>

        )


    }


    const changeRegMode = () =>{
        console.log("Смена режима")
        if(orderData?.regMode === 1) dispatch(setOrderData({...orderData,regMode: 0}))
        if(orderData?.regMode === 2) dispatch(setOrderData({...orderData,regMode: 0}))

    }




    async function  handleActionInn ( item: IActionItem) {

        //Прогоняем все акции в  синхроне
        if(! orderData?.orderId || !orderData?.sessionId) return false
        couponActionData.current ={
            couponId:coupon,
            sessionId: orderData?.sessionId,
            action : item?.name,
            data: item?.data,
            orderId: orderData?.orderId
        }
        //Ждем запрос
        const x = await exActionCoupon()
        if(! x?.success)
        {
            if(couponResult.current) couponResult.current.show(x?.errorAsString ? x?.errorAsString : "Ошибка сервера", true, 5000)
            return false
        }

        return true
    }

    const canNext = ()=>{
        // Если хоть одна не валидная акция то дизеблим кнопку
        const x =couponAction.filter((item)=> (item?.waitComplete && !item.valid) )
        return !x.length;



    }


    async function handleNext(){

        //Выполняем все акции если хоть одна не гуд то next не делаем
        let good = true
        await Promise.all( couponAction?.map(async (item)=>{
            if(item.handle)
            {
                const  x =await item.handle(item)
                if(! x ) good = false
            }
        }) )
        if(good && cbExecute)cbExecute()
    }


    return(
        <div className={styles.cont}>
            <div className={styles.title}>Если у Вас есть купон [ промокод ] на скидку - можете им воспользоваться здесь</div>
            <div className={styles.coupMain}>
                <div className={styles.coupCont}>
                    <div className={styles.inpNoteCont}>
                        <div className={styles.coupText}>Купон на скидку</div>
                    </div>

                        <input type="text" className="form-control form-control-sm" id="inputEmail4" placeholder={"купон"}
                               value={coupon}
                            //onBlur={()=>validateById("name")}
                               onChange={(e)=>setCoupon(e.target.value)}
                               maxLength={15}
                               onKeyDown={(e)=>{
                                   if(e?.key === "Enter") handleCoupon()
                               }}



                        >
                        </input>

                    <div className={styles.coupBtnCont}>
                        <button type="button" className="btn btn-face"
                                onClick={()=>{
                                    //setDiscount(1000)
                                    //dispatch(setOrderData({...orderData,tarifData: {...orderData.tarifData, price: 333} }))
                                    //if(couponResult.current)couponResult.current.show(`Ваша скидка ${1000} рублей активирована`,false,0)
                                    handleCoupon()

                                }}
                        >Применить</button>
                        <div className={styles.coupLdrCont}>
                            <WaitLoader loading={ldrCoupon || ldrActionCoupon} api={rsCoupon} onlyLoading={true} >
                            </WaitLoader>
                        </div>

                    </div>
                </div>


            </div>



            <div className={styles.coupRs}>
                <ErrorLineItem ref={couponResult} ></ErrorLineItem>
            </div>
            {showLink &&
                <span className={styles.cpLinkText}>Тарифы для этого купона <Link className={styles.cpLink} to={link}>здесь</Link></span>
            }

            {showNote &&
                <div className={styles.inpNote}><span>Не забудьте нажать кнопку «применить»</span></div>
            }

            <div className={styles.btnLine}>


                <button type="button" className="btn btn-face"
                        disabled={ !canNext()}

                        onClick={()=>{
                            //setDiscount(1000)
                            //dispatch(setOrderData({...orderData,tarifData: {...orderData.tarifData, price: 333} }))
                            //if(couponResult.current)couponResult.current.show(`Ваша скидка ${1000} рублей активирована`,false,0)
                            handleNext().then()

                        }}
                >Продолжить</button>

            </div>


        </div>
    )
}